import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

function Instructions ({ item }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className='ins-content'>
      <span className='Instructions-btn' onClick={() => setVisible(true)}> <span className='material-icons'>menu_book</span> Application instructions</span>
      <Modal width={1000} visible={visible} footer={false} closeIcon={false} closable={false} onCancel={() => setVisible(false)}>
        <div className='Instructions-body'>
          <div>
            <h1>{item.step_title}</h1>
            <p style={{ whiteSpace: 'pre-line' }}>{item.step_description}</p>
            <Button type='primary' onClick={() => setVisible(false)}>Start job application</Button>
          </div>
          <div>
            <img className='contentimage' src='/images/vetsmith-hero.png' alt='Vetsmith-Instructions'/>
          </div>
        </div>
      </Modal>
    </div>
  );
}

Instructions.propTypes = {
  item: PropTypes.any
};

export default Instructions;
